// Matt: "Tutorials that would allow anyone who needed it to learn how to
// play the game. They should be interactive, not just rulebook dumps."
// Same pattern as the sister thunderstone repo's own src/tutorial/
// thunderstoneSteps.js.
//
// TUTORIAL_SEED: a specific, hand-picked seed (not random) so the
// tutorial always starts with the player (p1) going first and no
// pending setup placement to resolve first - found by brute-forcing
// createGameState() across seeds 1-80 (see the commit that added this
// file). Step text is written in generic terms rather than referencing
// exact ship names/costs, since those depend on the seed's shuffle and
// aren't the point being taught (the dice/allocation/sector loop is).
export const TUTORIAL_SEED = 1;

// Each step: { id, title, text, target (a CSS selector to spotlight -
// omit for a plain centered callout), isComplete(state, baseline) -
// omit for a manual "Next" button. `baseline` is a snapshot of
// gameState taken the moment this step became current.
export const SPACE_BASE_TUTORIAL_STEPS = [
  {
    id: 'welcome',
    title: 'Welcome to Space Base!',
    text: 'This is a quick, hands-on walkthrough of your very first turn. You\'ll actually play as you go - nothing here is just text to read. Tap "Next" to begin, or "Skip tutorial" any time.',
  },
  {
    id: 'sectors',
    title: 'Your Sectors',
    text: 'You have 12 numbered sectors. Rolling a number that matches one collects its reward - every player collects from their OWN board, not a shared one.',
    target: '.console__sectors',
  },
  {
    id: 'stats',
    title: 'Credits, Income, and VP',
    text: 'Credits are spent to buy. Income is a permanent bonus you collect every future turn. Victory Points are what actually wins the game.',
    target: '.console__tab-stats',
  },
  {
    id: 'offer',
    title: 'Ships and Colonies',
    text: 'Buy a ship here to upgrade one of your sectors, or a colony for an even stronger, permanent one. Ships are organized by level - higher levels cost more.',
    target: '.game-board__offer-tabs',
  },
  {
    id: 'roll',
    title: 'Give it a try',
    text: 'Tap "Roll dice" to start your turn.',
    target: '[data-glossary="action-roll"]',
    isComplete: (state) => Boolean(state.meta.dice),
  },
  {
    id: 'allocate',
    title: 'Sum or Separate',
    text: 'Now choose: take your two dice added together as one number, or as two separate numbers. Whichever sector number(s) you pick, you\'ll collect that reward.',
    target: '[data-glossary="dice-sum-separate"]',
    isComplete: (state) => state.meta.turnPhase === 'post-reward',
  },
  {
    id: 'buy-or-skip',
    title: 'Buy if you can',
    text: 'If you can afford a ship or colony now, tap it to buy. If not, tap "Skip buy" to move on - either way is fine.',
    target: '.game-board__offer-tabs',
    isComplete: (state) => state.meta.turnPhase === 'post-buy',
  },
  {
    id: 'end-turn',
    title: 'End your turn',
    text: 'Tap "End turn" to pass the roll along.',
    target: '[data-glossary="action-end-turn"]',
    isComplete: (state, baseline) => state.meta.turnNumber > baseline.turnNumber || state.meta.activePlayerIndex !== baseline.activePlayerIndex,
  },
  {
    id: 'wrap-up',
    title: 'That\'s a full turn!',
    text: 'Keep rolling, collecting, and buying - the first player to reach the Victory Point target wins. If you ever forget what something means, tap the ? Glossary button and then tap the thing you\'re unsure about - it works on anything, any time.',
  },
];
